export default {"src":"/_next/static/media/rupee.ea9c01e1.svg","height":40,"width":36,"blurWidth":0,"blurHeight":0};